import React from "react";
import Navigation from "../../../components/Navigation";
import CreateProjectForm from "./CreateProjectForm/CreateProjectForm";

const CreateProject = () => {
  return (
    <div>
      <Navigation />
      <CreateProjectForm />
    </div>
  );
};

export default CreateProject;